import request from '@/utils/request'

const Api = {
  // 获取验证码
  getcode: (params = {}) => request.post('/login/getVerificationCode', params),
  // 注册接口
  userSave: (params = {}) => request.post('/user/save', params),
  // 登录接口
  saveLoginInfo: (params = {}) => request.post('/login/saveLoginInfoSh', params),
  // 提交
  submitApplyInfo: (params = {}) => request.post('/apply/submitApplyInfo', params),
  // 查询字典
  listDictByParentCodes: (params) => request.get('/dict/listDictByParentCodes', { params }),
  // 获取被申请人名称
  getEntrustingDepartList: (params) => request.get('/dict/getEntrustingDepartList' + '/' + params),
  // 详情
  detail: (params = {}) => request.post('/handleCase/getCaseDetail', params),
  oldDetail: (params = {}) => request.post('/apply/caseInfo/detail', params),
  // 上传文件
  uploadFile: (params = {}) => request.post('/file/upload', params, { headers: { 'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>' } }),
  // 新的上传文件
  appletsUpload: (params = {}) => request.post('/file/appletsUpload', params, { headers: { 'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>' } }),
  // 验证码校验
  checkCerificationCode: (params = {}) => request.post('/login/checkCerificationCode', params),
  // 删除文件
  deleteFileById: (params) => request.get(`/file/delete/${params}`),
  // 文件下载
  downloadFile: (params) => request.get('/file/download', { params, responseType: 'blob' }, { headers: { 'Content-Type': 'application/json; charset=UTF-8' } }),
  // 文字查询
  getDescribeTex: (params) => request.get('/login/getDescribeText', { params }),
  // 文书公开列表
  getList: (params = {}) => request.post('/overt/getList', params),
  // 获取复议机关
  getAgency: (params) => request.get('/handleCase/getAgency', { params }),
  // 撤回
  revoke: (params = {}) => request.post('/apply/withdrawApply', params),
  // 撤回
  oldrevoke: (params = {}) => request.post('/handleCase/caseInfo/revokeStatus', params),
  // 提交补正/申请
  saveOrUpdateCaseInfo: (params = {}) => request.post('/handleCase/saveOrUpdateCaseInfo', params),
  //  补充
  replenish: (params = {}) => request.post('/handleCase/replenish', params),
  // 提交补正
  correctApplyInfo: (params = {}) => request.post('/apply/submitCorrectionInfo', params),
  // 判断用户姓名和身份证号是否匹配人口库
  checkUsers: (params = []) => request.post('/handleCase/batchCheck', params),
  // ocr识别
  imgOcr: (params = {}) => request.post('/handleCase/imgocr/idcard', params),
  // 获取对应申请人的复议机关匹配
  getEntrustingAllDepartList: (params = {}) => request.get('/dict/getEntrustingAllDepartList', params),
  // 获取被申请人树形数据
  getEntrustingAllDepartTree: (params = {}) => request.get('/dict/getEntrustingAllDepartTree?name=' + params.name, params),
  // 生成预览申请书
  reconsiderApplyExportWord: (params = {}) => request.post('/file/reconsiderApplyExportWord', params),
  // 生成撤回申请书
  WithdrawApplyExportWord: (params = {}) => request.get(`/file/WithdrawApplyExportWord?caseOrderNo=${params.caseOrderNo}&withdrawSource=${params.withdrawSource}&caseSource=4&signFileUrl=${params.signFileUrl}`, params),
  // 案件列表
  getCaseList: (params = {}) => request.post('/handleCase/getCaseList', params),
  // 获取历史申请文书
  wsHistory: (params = {}) => request.get('/file/wsHistory/' + params.number, params),
  // 检验一个月10次
  applyCheck: (params = {}) => request.post('/handleCase/applyCheck', params),

  correctionCheck: (params = {}) => request.post('/handleCase/correctionCheck', params),

  // 授权入口
  authorize: (params = {}) => request.get('/ssb/newOauth/authorize?state=' + params.state, params),

  // 获取随申办的token
  accessToken: (params = {}) => {
    console.log(params)
    return request.post('/ssb/newOauth/accessToken?code=' + params.code, params)
  },

  // 获取用户基本信息
  getUserInfo: (params = {}) => request.post('/ssb/newOauth/userInfo?access_token=' + params.access_token + '&username=' + params.username, params),

  // 刷新
  refrcesh: (params = {}) => request.post('/ssb/newOauth/refresh/accessToken?access_token=' + params.access_token + '&username=' + params.username, params),

  // 撤回申请书文档
  withdrawApplyUploadFileData: (params = {}) => request.post('/apply/withdrawApplyUploadFileData', params),

  // 判断是否有案号
  caseOrderNoCheck: (params = {}) => request.post('/handleCase/caseOrderNoCheck'  , params),
  // 人脸识别相关接口-获取用户id
  postUserFaceInsert: (params) => request.post('/userFace/insert', params),
  getUserFaceAuthenticated: (id) => request.get('userFace/isAuthenticated?id=' + id),

  // 小程序授权-后获取用户信息
  getUser: (params = {}) => request.post('/ssb/newOauth/getUser?access_token='+ params.access_token, params),

  // 签名坐标存取
  saveSignaturePaths: (params = {}) => request.post('/signatureInfo/insert', params),
  getSignaturePaths: (params = {}) => request.post('/signatureInfo/getSignature', params),
  // 获取token
  getToken: (params = {}) => request.post('/login/wechat/token', params),

  // 阅卷相关接口
  // 提交申请阅卷
  submitReviewApply: (params = {}) => request.post('/handleCase/caseReviewFiles/submitApply', params),
  // 在线阅卷签名确认（生成文书）
  sginConfirm: (params = {}) => request.post('/handleCase/caseReviewFiles/sginConfirm', params),
  // 在线阅卷（上传签名后调用）
  onlineReview: (params = {}) => request.post('/CaseReviewFiles/onlineReview', params),
  // 获取阅卷文件列表
  getReviewFiles: (params = {}) => request.post('/CaseReviewFiles/getReviewFiles', params),
  // 获取阅卷文件列表（用于在线阅卷）
  getReviewFileList: (caseOrderNo) => request.get(`/handleCase/caseReviewFiles/getReviewFileList/${caseOrderNo}`),
  // 阅卷文件下载（后端逐页水印，返回文件流）
  downloadReviewFile: (params) => request.get('/handleCase/caseReviewFiles/download', { params, responseType: 'blob' }),
  // 获取最新询问意见
  getLatestOpinion: (params = {}) => request.get('/listenOpinion/getByCaseOrderNo?caseOrderNo=' + params.caseOrderNo),
  // 提交听取意见
  addOpinion: (params = {}) => request.post('/listenOpinion/addOpinion', params),
  // 检查用户是否已注册
  checkUserExistByPhoneAndIdentificationCard: (identificationCard, phone) => request.get(`/user/checkUserExistByPhoneAndIdentificationCard/${identificationCard}/${phone}`),
  // 获取注册异常弹窗内容
  getRegestStatusDialogContent: (params) => request.get('/tipsConf/getByModelType', { params: { modelType: 'registError' } }),
  // 获取版本更新提示
  getVersionUpdateTip: (params) => request.get('/tipsConf/getByModelType', { params: { modelType: 'versionUpdate' } }),
  // 检查是否可以跳过人脸识别（用于撤回案件）
  checkOperationPhone: (params = {}) => request.post('/handleCase/checkOperationPhone', params),
  // 网上提交申规则校验
  checkApplyRule: (params = {}) => request.get('/handleCase/caseInfo/firewallTip' + '?evidenceId=' + params.evidenceId)
}
export default Api
